<template>
  <a>
    <div>
      <div class="macc-main ">
        <!--<div class="macc-logo-title">
        <div>
          <img src="{{assetsUrl}}imgs/course/macc/IMA.png">
        </div>
        <div>
          <img src="{{assetsUrl}}imgs/course/macc/MACC.png">
        </div>
      </div>-->
        <div class="macc-content" style=" height: 100%;">
          <div v-if="data.courseType === '999'">
            <img class="back-img" :src="`${assetsUrl}imgs/course/macc/kjsw-macc.jpg`" style="width:1000px;margin: 0 auto; display: flex;"  />
            <!--  <div id="maccCenter" class="enter" style="top:auto; bottom: 11rem;">{{data.formatTime}}温暖上线</div> -->
            <a
              id="maccIn"
              :href="data.classesUrls[0].url"
              @click="isIn(data.classesUrls[0].url)"
              target="_blank"
              class="enter"
              style="top:auto; bottom: 11rem;"
            >进入</a
            >

            <a
              :href="user.licenseCode == 'paikaiedu' ? 'http://www.paikaiedu.com/dc.html?introduce&type=pkIntroduce' : 'http://apoit.org/dc.html?introduce&type=mainPoint&certificatesType='+ (data.courseType == '998' ? '1' : '2') "
              target="_blank"
              style="top: 30rem;"
              class="outline"
            >考试大纲 >></a
            >
          </div>
          <div v-if="data.courseType === '998'">
            <img class="back-img" :src="`${assetsUrl}imgs/course/macc/kjsw-cw.jpg`" style="width:1000px;margin: 0 auto; display: flex;" />
            <!-- <img class="back-img" :src="`${assetsUrl}}imgs/course/macc/kjsw-macc.jpg`"/> -->
            <!--  <div id="maccCenter" class="enter" style="top:auto; bottom: 11rem;">{{data.formatTime}}温暖上线</div>  -->
            <a
              id="maccIn"
              :href="data.classesUrls[0].url"
              @click="isIn(data.classesUrls[0].url)"
              target="_blank"
              class="enter"
              style="top:auto; bottom: 11rem;"
            >进入</a
            >

            <a
              :href="user.licenseCode == 'paikaiedu' ? 'http://www.paikaiedu.com/dc.html?introduce&type=pkIntroduce' : 'http://apoit.org/dc.html?introduce&type=mainPoint&certificatesType='+ (data.courseType == '998' ? '1' : '2') "
              target="_blank"
              style="top: 30rem;"
              class="outline"
            >考试大纲 >></a
            >
          </div>
          <div v-if="data.courseType === '997'">
            <!-- <img class="back-img" :src="`${assetsUrl}imgs/course/macc/kjsw-cwzg.jpg`" /> -->
            <img class="back-img" :src="`${assetsUrl}imgs/course/macc/kjsw-cwzg.jpg`" style="width:1000px;margin: 0 auto; display: flex;" />
            <!--  <div id="maccCenter" class="enter" style="top:auto; bottom: 11rem;">{{data.formatTime}}温暖上线</div>  -->
            <a
              id="maccIn"
              :href="data.classesUrls[0].url"
              @click="isIn(data.classesUrls[0].url)"
              target="_blank"
              class="enter"
              style="top:auto; bottom: 11rem"
            >进入</a
            >

            <a
              :href="user.licenseCode == 'paikaiedu' ? 'http://www.paikaiedu.com/dc.html?introduce&type=pkIntroduce' : 'http://apoit.org/dc.html?introduce&type=mainPoint&certificatesType='+ (data.courseType == '997' ? '1' : '2') "
              target="_blank"
              style="top: 30rem;"
              class="outline"
            >考试大纲 >></a
            >
          </div>
          <div class="madp-block" v-if="data.courseType === '1000'" >
            <!-- <img class="back-img" :src="`${assetsUrl}imgs/course/macc/MADP_back.jpg`" /> -->
            <img class="back-img" :src="`${assetsUrl}imgs/course/macc/MADP_back.jpg`" style="width:1000px;margin: 0 auto; display: flex;" />
            <a
              class="madp-content"
              id="maccIn"
              :href="data.classesUrls[0].url"
              @click="isIn(data.classesUrls[0].url)"
              target="_blank"
            >
            </a>
          </div>
          <!--<img class="mess-logo" src="{{assetsUrl}}imgs/course/macc/maccLogo.png">-->
        </div>
      </div>
    </div>
  </a>
</template>
<script>
// import url from 'socket.io-client/lib/url'
export default {
  name: 'MockMacc',
  components: {},
  data() {
    return {
      classesId: '',
      planclassesId: '',
      user: '',
      assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
    }
  },
  props: {
    data: {
      type: Object,
      default: null,
      required: false
    },
    couserType: {
      type: String,
      default: '',
      required: false
    },
  },
  created() {
    console.log(this.data.courseType)
    // this.data.courseType =
    // this.isXueli = this.xueLiType.indexOf(this.courseType) > -1
    // this.getList()
  },
  methods: {
    isIn(item) {},
    chechTimeOut() {
    }
  }
}
</script>
<style scoped lang="less">
.title {
  margin-left: 4.4rem;
  margin-top: 2.6rem;
}
.title img {
  display: inline-block;
}
.logo-title {
  margin-left: 2rem;
  width: 25rem;
  margin-top: 0.8rem;
}
.main-div {
  width: 45.75rem;
  height: 23rem;
  background-color: white;
  border-radius: 0.6rem;
  margin-top: 3.4rem;
  margin-left: 2.7rem;
  box-shadow: 0px 3px 13px rgba(0, 0, 0, 0.4);
}
.bottom-content {
  color: #cff6ff;
  font-size: 14px;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 18rem;
}
.tiku-title {
  font-size: 1.5rem;
  color: #333;
  width: 100%;
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
.tiku-main {
  width: 100%;
  height: 17rem;
  display: flex;
  flex-flow: row wrap;
  padding-left: 5rem;
  padding-top: 1rem;
}
.enter {
  height: 3.3rem;
  width: 15.8rem;
  border: none;
  margin-right: 4rem;
  font-size: 1rem;
  border-radius: 1.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  line-height: 3.3rem;
  outline: none;
}
.able-in {
  color: #08528f;
  background-color: #d8edff;
  box-shadow: 0px 2px 0px #b4deff;
}
.disable-in {
  color: #777;
  background-color: #d4dce2;
  box-shadow: 0 2px 0 #b3c0ca;
}
.able-in:hover {
  background-color: #98d172;
  color: white;
  box-shadow: none;
}
.disable-icon {
  font-size: 1.3rem;
  left: 0.5rem;
  float: left;
}

.able-in:active {
  box-shadow: 0 7px 5px rgba(0, 0, 0, 0.3) inset;
}

@media (min-height: 750px) and (max-height: 825px) {
  .inner-div,
  .macc-main {
    // margin-top: 5rem;
    margin-bottom: 1rem;
  }
}
@media (min-height: 600px) and (max-height: 750px) {
  .inner-div,
  .macc-main {
    // margin-top: 8rem;
    margin-bottom: 3rem;
  }
  .macc-main {
    // margin-top: 10rem;
  }
}
@media (min-height: 600px) and (max-height: 680px) {
  .macc-main {
    // margin-top: 15rem;
  }
}
@media screen and (max-height: 600px) {
  .inner-div,
  .macc-main {
    // margin-top: 18rem;
  }
}
.macc-main {
  // width: 51.3rem;
  height: 38.5rem;
  background-color: white;
  border: 0.05rem solid #e3e3e3;
}
.macc-logo-title {
  height: 8.7rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title > div {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.macc-logo-title img {
  width: 14rem;
}
.macc-content {
  width: 100%;
  height: 29.7rem;
  position: relative;
}
.macc-text {
  width: 21.2rem;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  left: 0;
  margin: auto;
  font-size: 1.1rem;
  color: #fff;
}
.macc-content > .back-img {
  width: 100%;
  height: 100%;
}
.macc-content .enter {
  position: absolute;
  top: 6rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  background-color: white;
  color: #ff7214;
  font-size: 1.1rem;
  box-shadow: 0px 3px 0px #b1dbd9;
  text-align: center;
  text-decoration: none;
}
.macc-content > .mess-logo {
  width: 21.2rem;
  position: absolute;
  top: -10rem;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
//.macc-content .enter:hover{
//  background-color: #98d172;
//  color: white;
//  box-shadow:none;
//}

//.macc-content .enter:active{
//  box-shadow: 0 7px 5px rgba(0, 0, 0, .3) inset;
//}
.outline {
  position: absolute;
  margin: auto;
  width: 11.5rem;
  top: 22rem;
  left: 0;
  right: 0;
  text-align: center;
  color: #fff;
  text-decoration: none;
  box-shadow: 0 0.1rem 0 #c5e1b1;
  font-size: 1rem;
  height: 1.25rem;
  line-height: 1.25rem;
}
.outline:hover {
  color: #98d172;
  box-shadow: 0 0.1rem 0 #98d172;
}

.madp-block {
  position: relative;

  img {
    cursor: context-menu;
  }
  .madp-content {
    height: 70px;
    width: 350px;
    display: inline-block;
    position: absolute;
    top: 380px;
    left: 40%;
  }
}
</style>
